import styled from 'styled-components';

import { Text } from '@/nova/components';
import { CFG } from '../../../../theme/configurator-tokens';
import { COUNTRY } from '../country.tokens';

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
  background: ${COUNTRY.backdrop};
  backdrop-filter: blur(8px);
`;

export const Panel = styled.div`
  position: absolute;
  inset: 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 20px;
  border: 1px solid ${COUNTRY.panelBorder};
  background: ${COUNTRY.panelBg};
`;

export const Header = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: 28px 32px;
`;

export const CloseButton = styled.button`
  display: flex;
  width: 32px;
  height: 32px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 9999px;
  background: ${COUNTRY.closeBg};
  color: ${CFG.foreground};
  transition: background-color 150ms ease;

  &:hover {
    background: ${COUNTRY.closeHover};
  }
`;

export const Hairline = styled.div`
  height: 1px;
  width: 100%;
  background: ${COUNTRY.hairline};
`;

export const Body = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 32px;
`;

export const Hero = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  border-radius: 16px;
  padding: 32px;
  background: ${COUNTRY.heroBg};
`;

export const HeroText = styled.div`
  display: flex;
  max-width: 487px;
  flex-direction: column;
  gap: 12px;
`;

export const Title = styled(Text)`
  font-size: 28px;
  font-weight: 700;
  line-height: 1.1;
  color: ${CFG.foreground};
`;

export const Subtitle = styled(Text)`
  font-size: 14px;
  font-weight: 300;
  line-height: 1.2;
  color: ${CFG.base400};
`;

export const SearchLabel = styled.label`
  display: flex;
  height: 52px;
  width: 340px;
  max-width: 100%;
  align-items: center;
  gap: 8px;
  border-radius: 9999px;
  background: ${CFG.base100};
  padding: 0 18px;
`;

export const SearchInput = styled.input`
  width: 100%;
  border: 0;
  background: transparent;
  font-size: 14px;
  color: ${CFG.foreground};

  &::placeholder {
    color: ${CFG.base500};
  }
  &:focus {
    outline: none;
  }
`;

export const Groups = styled.div`
  margin-top: 16px;
  display: flex;
  flex-direction: column;
`;

export const Empty = styled(Text)`
  padding: 48px 8px;
  font-size: 14px;
  color: ${CFG.base500};
`;

export const Group = styled.div`
  display: flex;
  flex-direction: column;
`;

export const GroupName = styled(Text)`
  padding: 32px 8px 12px;
  font-size: 22px;
  font-weight: 300;
  line-height: 1.2;
  color: ${CFG.base400};
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 12px;

  ${COUNTRY.gridSm} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  ${COUNTRY.gridLg} {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
`;

export const Row = styled.button<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  border: none;
  border-radius: 10px;
  padding: 10px 8px;
  text-align: left;
  background: transparent;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.4 : 1)};
  transition: background-color 150ms ease;

  &:hover {
    background: ${({ $disabled }) => ($disabled ? 'transparent' : COUNTRY.rowHover)};
  }
`;

export const FlagWrap = styled.span`
  display: flex;
  height: 24px;
  width: 34px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
`;

export const FlagImg = styled.img`
  height: 24px;
  width: auto;
  max-width: 34px;
  border-radius: 3px;
  object-fit: contain;
`;

export const RowName = styled(Text)<{ $selected?: boolean }>`
  font-size: 18px;
  line-height: 20px;
  font-weight: ${({ $selected }) => ($selected ? 700 : 400)};
  color: ${({ $selected }) => ($selected ? CFG.brandText : CFG.foreground)};
`;

export const SoonPill = styled(Text)`
  flex: 0 0 auto;
  padding: 2px 8px;
  border-radius: 9999px;
  background: ${CFG.washHover};
  color: ${CFG.base400};
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;
`;
